import {Injectable} from '@angular/core';
import {ApiRequestService} from './api-request.service';
import {AppConfig} from '../../app-config';
import {Observable} from 'rxjs';
import { ColdStore } from '../../pages/user-management/cold-store/cold-store.model';

@Injectable()
export class CommonService {


    constructor(private apiRequest: ApiRequestService,
                private appConfig: AppConfig) {
    }

    // get count
    getCount(): Observable<any> {
        return this.apiRequest.get(this.appConfig.common_url);
    }

    getCountWithFilter(data: ColdStore): Observable<any> {
        return this.apiRequest.post(this.appConfig.cold_store_url + '/filters/count?p=0&l=10000', data);
    }

}
